/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';

import {AppContext} from '../misc/appContext';

import {SubscriptionModuleName} from '../../util/enums';

import {BolmateBadge} from '../controls';

export default function BolmateBadgePremium() {
    const {t} = useTranslation();
    const {user} = useContext(AppContext).userContext;
    const module = user?.subscription?.getModule(SubscriptionModuleName.NOTIFICATIONS);
    const isTrialing = module?.isTrialing();
    return (
        <div className='premium-notification-label-container'>
            <BolmateBadge label={t('notifications.components.premiumBadge', 'Premium')} color='gold' />
            <p className='premium-notification-info'>
                {t(
                    'notifications.components.premiumInfo',
                    'Deze notificatie is een premium notificatie en is beschikbaar via de Notificaties module.'
                )}
                {isTrialing && (
                    <>
                        <br />
                        {t(
                            'notifications.components.premiumTrialInfo',
                            'Gratis te gebruiken gedurende jouw proefperiode.'
                        )}
                    </>
                )}
            </p>
        </div>
    );
}
